module.exports = {
  version: '/api/v1', // 接口前缀、版本
  timeOut: 60000, // 超时
};



// WEBPACK FOOTER //
// ./src/api/config.js